import React from 'react';
import { Row } from '@components/form/Form/Form';
import * as TextField from '@components/form/TextField/TextField';
import { PublicTransitStopEntity } from '@api/entities/replancity_PublicTransitLine';
import Tooltip from '@mui/material/Tooltip';
import './transit-stop-row-form.scss';

type Props = {
    entity: Pick<PublicTransitStopEntity, 'id' | 'name' | 'routes'>;
};

const TransitStopRowForm = ({ entity }: Props) => {
    const { routes } = entity;

    return (
        <Row>
            <TextField.default
                name="name"
                type="text"
                value={entity?.name ?? entity?.id}
                linkable
            />
            <Tooltip title="routes" placement="top" disableInteractive>
                <div className="entities-list-row__routes">{routes ?? 0}</div>
            </Tooltip>
        </Row>
    );
};

export default TransitStopRowForm;
